import {
  createAsyncThunk,
  createSlice,
} from "@reduxjs/toolkit";

import API from "../../utils/apiCalling";
import { config } from "../../utils/apiUrl";


/*
|--------------------------------------------------------------------------
| GET CURRENT SUBSCRIPTION
|--------------------------------------------------------------------------
*/

export const getCurrentSubscription =
  createAsyncThunk(
    "tenantSubscription/getCurrentSubscription",

    async (
      _,
      {
        rejectWithValue,
      }
    ) => {

      try {

        const api =
          new API();


        const response =
          await api.get(
            config
              .getCurrentTenantSubscription
          );


        if (
          response?.success ===
          false
        ) {

          return rejectWithValue(
            response?.message ||
            "Unable to load subscription."
          );

        }


        return (
          response?.data ||
          null
        );

      } catch (
        error
      ) {

        return rejectWithValue(
          error?.response
            ?.data
            ?.message ||
          error?.message ||
          "Unable to load subscription."
        );

      }

    }
  );


/*
|--------------------------------------------------------------------------
| GET PLANS
|--------------------------------------------------------------------------
*/

export const getSubscriptionPlans =
  createAsyncThunk(
    "tenantSubscription/getSubscriptionPlans",

    async (
      _,
      {
        rejectWithValue,
      }
    ) => {

      try {

        const api =
          new API();


        const response =
          await api.get(
            config
              .getTenantSubscriptionPlans
          );


        if (
          response?.success ===
          false
        ) {

          return rejectWithValue(
            response?.message ||
            "Unable to load subscription plans."
          );

        }


        return (
          response?.data ||
          []
        );

      } catch (
        error
      ) {

        return rejectWithValue(
          error?.response
            ?.data
            ?.message ||
          error?.message ||
          "Unable to load subscription plans."
        );

      }

    }
  );


/*
|--------------------------------------------------------------------------
| SELECT PLAN
|--------------------------------------------------------------------------
*/

export const selectSubscriptionPlan =
  createAsyncThunk(
    "tenantSubscription/selectSubscriptionPlan",

    async (
      payload,
      {
        rejectWithValue,
      }
    ) => {

      try {

        const api =
          new API();


        const response =
          await api.post(
            config
              .selectTenantSubscriptionPlan,

            payload
          );


        if (
          response?.success ===
          false
        ) {

          return rejectWithValue(
            response?.message ||
            "Unable to select subscription plan."
          );

        }


        return (
          response?.data ||
          null
        );

      } catch (
        error
      ) {

        return rejectWithValue(
          error?.response
            ?.data
            ?.message ||
          error?.message ||
          "Unable to select subscription plan."
        );

      }

    }
  );


/*
|--------------------------------------------------------------------------
| CREATE SUBSCRIPTION PAYMENT ORDER
|--------------------------------------------------------------------------
*/

export const createSubscriptionPaymentOrder =
  createAsyncThunk(
    "tenantSubscription/createSubscriptionPaymentOrder",

    async (
      {
        subscriptionId,
      },
      {
        rejectWithValue,
      }
    ) => {

      try {

        const api =
          new API();


        const response =
          await api.post(
            config
              .createTenantSubscriptionPaymentOrder,

            {
              subscriptionId,
            }
          );


        if (
          response?.success ===
          false
        ) {

          return rejectWithValue(
            response?.message ||
            "Unable to create payment order."
          );

        }


        return (
          response?.data ||
          null
        );

      } catch (
        error
      ) {

        return rejectWithValue(
          error?.response
            ?.data
            ?.message ||
          error?.message ||
          "Unable to create payment order."
        );

      }

    }
  );


/*
|--------------------------------------------------------------------------
| VERIFY SUBSCRIPTION PAYMENT
|--------------------------------------------------------------------------
*/

export const verifySubscriptionPayment =
  createAsyncThunk(
    "tenantSubscription/verifySubscriptionPayment",

    async (
      {
        subscriptionId,

        razorpay_order_id,

        razorpay_payment_id,

        razorpay_signature,
      },
      {
        rejectWithValue,
      }
    ) => {

      try {

        const api =
          new API();


        const response =
          await api.post(
            config
              .verifyTenantSubscriptionPayment,

            {
              subscriptionId,

              razorpay_order_id,

              razorpay_payment_id,

              razorpay_signature,
            }
          );


        if (
          response?.success ===
          false
        ) {

          return rejectWithValue(
            response?.message ||
            "Unable to verify payment."
          );

        }


        return (
          response?.data ||
          null
        );

      } catch (
        error
      ) {

        return rejectWithValue(
          error?.response
            ?.data
            ?.message ||
          error?.message ||
          "Unable to verify payment."
        );

      }

    }
  );


/*
|--------------------------------------------------------------------------
| INITIAL STATE
|--------------------------------------------------------------------------
*/

const initialState = {

  currentSubscription: {
    data:
      null,

    loading:
      false,

    error:
      null,
  },


  plans: {
    data:
      [],

    loading:
      false,

    error:
      null,
  },


  selectPlan: {
    data:
      null,

    loading:
      false,

    error:
      null,
  },


  paymentOrder: {
    data:
      null,

    loading:
      false,

    error:
      null,
  },


  verifyPayment: {
    data:
      null,

    loading:
      false,

    error:
      null,
  },


  subscriptionRequired:
    false,

  showSubscriptionPopup:
    false,

  popupType:
    null,

  reason:
    null,

  canSelectPlan:
    false,

  initialized:
    false,
};


/*
|--------------------------------------------------------------------------
| SLICE
|--------------------------------------------------------------------------
*/

const subscriptionSlice =
  createSlice({

    name:
      "tenantSubscription",

    initialState,


    reducers: {

      openSubscriptionPopup:
        (
          state
        ) => {

          state.showSubscriptionPopup =
            true;

        },


      closeSubscriptionPopup:
        (
          state
        ) => {

          state.showSubscriptionPopup =
            false;

        },


      clearSubscriptionPaymentState:
        (
          state
        ) => {

          state.paymentOrder = {

            data:
              null,

            loading:
              false,

            error:
              null,

          };


          state.verifyPayment = {

            data:
              null,

            loading:
              false,

            error:
              null,

          };

        },


      clearSelectPlanState:
        (
          state
        ) => {

          state.selectPlan = {

            data:
              null,

            loading:
              false,

            error:
              null,

          };

        },


      resetTenantSubscription:
        () =>
          initialState,

    },


    extraReducers:
      (
        builder
      ) => {

        /*
        |--------------------------------------------------------------------------
        | CURRENT SUBSCRIPTION
        |--------------------------------------------------------------------------
        */

        builder
          .addCase(
            getCurrentSubscription.pending,

            (
              state
            ) => {

              state
                .currentSubscription
                .loading =
                true;

              state
                .currentSubscription
                .error =
                null;

            }
          )

          .addCase(
            getCurrentSubscription.fulfilled,

            (
              state,
              action
            ) => {

              state
                .currentSubscription
                .loading =
                false;


              state
                .currentSubscription
                .data =
                action.payload
                  ?.subscription ||
                null;


              state.subscriptionRequired =
                action.payload
                  ?.subscriptionRequired ===
                true;


              state.showSubscriptionPopup =
                action.payload
                  ?.showSubscriptionPopup ===
                true;


              state.popupType =
                action.payload
                  ?.popupType ||
                null;


              state.reason =
                action.payload
                  ?.reason ||
                null;


              state.canSelectPlan =
                action.payload
                  ?.canSelectPlan ===
                true;


              state.initialized =
                true;

            }
          )

          .addCase(
            getCurrentSubscription.rejected,

            (
              state,
              action
            ) => {

              state
                .currentSubscription
                .loading =
                false;

              state
                .currentSubscription
                .error =
                action.payload;

              state.initialized =
                true;

            }
          );


        /*
        |--------------------------------------------------------------------------
        | PLANS
        |--------------------------------------------------------------------------
        */

        builder
          .addCase(
            getSubscriptionPlans.pending,

            (
              state
            ) => {

              state.plans.loading =
                true;

              state.plans.error =
                null;

            }
          )

          .addCase(
            getSubscriptionPlans.fulfilled,

            (
              state,
              action
            ) => {

              state.plans.loading =
                false;

              state.plans.data =
                Array.isArray(
                  action.payload
                )
                  ?
                  action.payload
                  :
                  [];

            }
          )

          .addCase(
            getSubscriptionPlans.rejected,

            (
              state,
              action
            ) => {

              state.plans.loading =
                false;

              state.plans.error =
                action.payload;

            }
          );


        /*
        |--------------------------------------------------------------------------
        | SELECT PLAN
        |--------------------------------------------------------------------------
        */

        builder
          .addCase(
            selectSubscriptionPlan.pending,

            (
              state
            ) => {

              state.selectPlan.loading =
                true;

              state.selectPlan.error =
                null;

            }
          )

          .addCase(
            selectSubscriptionPlan.fulfilled,

            (
              state,
              action
            ) => {

              state.selectPlan.loading =
                false;

              state.selectPlan.data =
                action.payload;

            }
          )

          .addCase(
            selectSubscriptionPlan.rejected,

            (
              state,
              action
            ) => {

              state.selectPlan.loading =
                false;

              state.selectPlan.error =
                action.payload;

            }
          );


        /*
        |--------------------------------------------------------------------------
        | CREATE PAYMENT ORDER
        |--------------------------------------------------------------------------
        */

        builder
          .addCase(
            createSubscriptionPaymentOrder.pending,

            (
              state
            ) => {

              state.paymentOrder.loading =
                true;

              state.paymentOrder.error =
                null;

            }
          )

          .addCase(
            createSubscriptionPaymentOrder.fulfilled,

            (
              state,
              action
            ) => {

              state.paymentOrder.loading =
                false;

              state.paymentOrder.data =
                action.payload;

            }
          )

          .addCase(
            createSubscriptionPaymentOrder.rejected,

            (
              state,
              action
            ) => {

              state.paymentOrder.loading =
                false;

              state.paymentOrder.error =
                action.payload;

            }
          );


        /*
        |--------------------------------------------------------------------------
        | VERIFY PAYMENT
        |--------------------------------------------------------------------------
        */

        builder
          .addCase(
            verifySubscriptionPayment.pending,

            (
              state
            ) => {

              state.verifyPayment.loading =
                true;

              state.verifyPayment.error =
                null;

            }
          )

          .addCase(
            verifySubscriptionPayment.fulfilled,

            (
              state,
              action
            ) => {

              state.verifyPayment.loading =
                false;

              state.verifyPayment.data =
                action.payload;

            }
          )

          .addCase(
            verifySubscriptionPayment.rejected,

            (
              state,
              action
            ) => {

              state.verifyPayment.loading =
                false;

              state.verifyPayment.error =
                action.payload;

            }
          );

      },

  });


export const {
  openSubscriptionPopup,
  closeSubscriptionPopup,
  clearSubscriptionPaymentState,
  clearSelectPlanState,
  resetTenantSubscription,
} =
  subscriptionSlice.actions;


export default
  subscriptionSlice.reducer;